import React, { useState } from 'react';

const PlanConsultation: React.FC = () => {
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
  };

  if (submitted) {
    return (
      <div className="flex flex-col items-center justify-center h-full text-center py-20 animate-fadeIn">
        <div className="h-20 w-20 rounded-full bg-green-500/10 flex items-center justify-center mb-6">
          <span className="material-symbols-outlined text-4xl text-green-500">check</span>
        </div>
        <h2 className="text-2xl font-bold text-white mb-2">Request Received</h2>
        <p className="text-white/60 max-w-xs">
          Our team will contact you shortly to schedule your consultation.
        </p>
        <button 
          onClick={() => setSubmitted(false)}
          className="mt-8 text-primary font-medium hover:underline"
        >
          Send another request
        </button>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-2">
        <h1 className="text-2xl font-bold text-white">Plan Consultation</h1>
        <p className="text-white/60 text-sm">Find the perfect membership for your needs.</p>
      </div>

      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <div className="space-y-1">
          <label className="text-xs font-medium text-white/70 uppercase tracking-wider ml-1">Name</label>
          <input 
            type="text" 
            required
            className="w-full rounded-lg bg-white/5 border border-white/10 p-4 text-white placeholder-white/30 focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary transition-all"
            placeholder="Your Name"
          />
        </div>
        
        <div className="space-y-1">
          <label className="text-xs font-medium text-white/70 uppercase tracking-wider ml-1">Contact</label>
          <input 
            type="email" 
            required
            className="w-full rounded-lg bg-white/5 border border-white/10 p-4 text-white placeholder-white/30 focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary transition-all"
            placeholder="Email or Phone"
          />
        </div>

        <div className="space-y-1">
          <label className="text-xs font-medium text-white/70 uppercase tracking-wider ml-1">Interest</label>
          <select className="w-full rounded-lg bg-white/5 border border-white/10 p-4 text-white focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary transition-all appearance-none">
            <option className="bg-[#2a2a2a]">Private Office</option>
            <option className="bg-[#2a2a2a]">Dedicated Desk</option>
            <option className="bg-[#2a2a2a]">Hot Desk</option>
            <option className="bg-[#2a2a2a]">Virtual Office</option>
          </select>
        </div>

        <div className="space-y-1">
           <label className="text-xs font-medium text-white/70 uppercase tracking-wider ml-1">Message (Optional)</label>
          <textarea 
            rows={4}
            className="w-full rounded-lg bg-white/5 border border-white/10 p-4 text-white placeholder-white/30 focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary transition-all"
            placeholder="Any specific requirements?"
          />
        </div>

        <button 
          type="submit"
          className="mt-4 w-full rounded-full bg-primary p-4 font-bold text-black shadow-lg shadow-primary/20 transition-transform active:scale-95 hover:bg-primary/90"
        >
          Request Consultation
        </button>
      </form>
    </div>
  );
};

export default PlanConsultation;